export function isValidUnitOverride(unitOverride: string): boolean {
  return unitOverride === 'm' || unitOverride === 'i';
}
